<template>
  <el-dialog :title="(goodsDetailData && goodsDetailData.type) == 'UPDATE' ? '编辑货物明细' : '新增货物明细'" :visible.sync="visible" width="720px" :before-close="closeDialog" :close-on-click-modal="false">
    <div>
      <el-form ref="goodsDetailData" :model="goodsDetailData" :rules="dangerType ? tableRuleDanger : tableRule" label-width="90px" size="small" label-position="top" :inline="true">
        <div>
          <el-form-item label="分提单号" prop="houseBillNo">
            <el-input v-model="goodsDetailData.houseBillNo" placeholder="请输入分提单号" style="width:320px" :maxlength="30" :minlength="6" show-word-limit :disabled="modifyType ? true : isEdit" @input="val => toupcaseTable(val, 'houseBillNo', goodsDetailData.$index)" @blur="val => trimTexTablet(val, 'houseBillNo', goodsDetailData.$index)"></el-input>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label="箱号" prop="containerNo">
            <el-input v-model="goodsDetailData.containerNo" placeholder="大写字母和数字(11位以内)" :maxlength="11" show-word-limit style="width:320px" :disabled="modifyType ? true : isEdit" @input="val => toupcaseTable(val, 'containerNo', goodsDetailData.$index)" @blur="val => trimTexTablet(val, 'containerNo', goodsDetailData.$index)" />
          </el-form-item>
          <el-form-item prop="sealNo">
            <span slot="label">
              <span class="span-box">
                <span>封号</span>
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">海关只允许最多11位字符的大写字母<br />和数字组合，超出末尾截断即可</div>
                  <i class="el-icon-question" style="color: #00A0E9;" />
                </el-tooltip>
              </span>
            </span>
            <el-input v-model="goodsDetailData.sealNo" placeholder="11个字符内" :maxlength="11" show-word-limit style="width:320px" :disabled="modifyType ? true : isEdit" @input="val => toupcaseTable(val, 'sealNo', goodsDetailData.$index)" @blur="val => trimTexTablet(val, 'sealNo', goodsDetailData.$index)" />
          </el-form-item>
        </div>
        <div>
          <el-form-item label="箱型" prop="containerType">
            <el-select v-model="goodsDetailData.containerType" @blur="handBlur('containerType')" placeholder="请选择箱型" style="width:320px" :disabled="modifyType ? true : isEdit" filterable>
              <el-option v-for="item in containerList" :key="item.code" :value="item.code" :label="item.show" />
            </el-select>
          </el-form-item>
        </div>

        <div class="flex">
          <el-form-item label="唛头" prop="marksNumber" label-width="100px">
            <el-input type="textarea" :rows="4" v-model.trim="goodsDetailData.marksNumber" placeholder="请输入唛头" :maxlength="255" style="min-height: 96px;width: 320px;" :disabled="isEdit" @input="val => toupcaseTable(val, 'marksNumber', goodsDetailData.$index)" @blur="val => trimTexTablet(val, 'marksNumber', goodsDetailData.$index)" />
          </el-form-item>
          <el-form-item label="货名" prop="descriptionOfGoods">
            <el-input type="textarea" :rows="4" v-model.trim="goodsDetailData.descriptionOfGoods" placeholder="请输入货名" :maxlength="255" style="min-height: 96px;width: 320px;" :disabled="modifyType ? true : isEdit" @input="val => toupcaseTable(val, 'descriptionOfGoods', goodsDetailData.$index)" @blur="val => trimTexTablet(val, 'descriptionOfGoods', goodsDetailData.$index)" />
          </el-form-item>
        </div>

        <div class="flex">
          <el-form-item label="件数" prop="packages">
            <el-input v-natural-number style="width:320px" controls-position="right" v-model="goodsDetailData.packages" placeholder="请输入件数" :min="0" :max="1000000" size="small" :disabled="isEdit" @blur="val => toFixedNum(val, 'packages', 0)" @input="timeNumInput" />
          </el-form-item>
          <el-form-item label="包装单位" prop="packageUnit">
            <el-select v-model="goodsDetailData.packageUnit" @blur="handBlur('packageUnit')" placeholder="请选择包装单位" :disabled="isEdit" :transfer="true" filterable remote reserve-keyword :loading="selectLoading" :remote-method="remoteMethodPackage" @change="changePackage" @focus="focusPackage" style="width:320px">
              <el-option v-for="item in packageList" :key="item.code" :value="item.code" :label="item.show"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label="毛重（KGS）" prop="grossWeight" label-width="100px">
            <el-input show-word-limit v-model="goodsDetailData.grossWeight" placeholder="请输入毛重(0.001~1000000.999)" :maxlength="11" style="width:320px" :disabled="isEdit" @blur="val => toFixedNum(val, 'grossWeight', 3)" />
          </el-form-item>
          <el-form-item label="体积（CBM）" prop="volume" label-width="100px">
            <el-input show-word-limit v-model="goodsDetailData.volume" placeholder="请输入体积(0.001~2000.999)" :maxlength="8" style="width:320px" :disabled="isEdit" @blur="val => toFixedNum(val, 'volume', 3)" />
          </el-form-item>
        </div>

        <div class="flex">
          <el-form-item label="危险品Code" prop="unCode" label-width="100px">
            <div style="position: relative;">
              <el-input v-natural-number show-word-limit v-model="goodsDetailData.unCode" @change="changeCode" placeholder="有且只能是4位数字" :maxlength="4" style="width: 320px;" :disabled="isEdit" @blur="val => fourNum(val, 'unCode', goodsDetailData.$index)" />
              <!-- <div v-if="reqUnCode(goodsDetailData.unCode)" style="position: absolute;bottom: -25px;color: #F56C6C;font-size: 12px;">有且只能是4位数字</div> -->
            </div>
          </el-form-item>
          <el-form-item label="危险品等级" prop="dangerLevel" label-width="100px">
            <div style="position: relative;">
              <el-input show-word-limit v-model="goodsDetailData.dangerLevel" @change="changeDanger" placeholder="请输入危险品等级" :maxlength="3" style="width: 320px;" :disabled="isEdit" @blur="val => toFixedNum(val, 'dangerLevel', 1)" />
              <!-- <div v-if="reqDangerLevel(scope.row.dangerLevel)" style="position: absolute;bottom: -25px;color: #F56C6C;font-size: 12px;">输入范围1.0~9.9</div> -->
            </div>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label="危险品联系人" prop="dgContact" label-width="100px">
            <div style="position: relative;">
              <el-input show-word-limit v-model="goodsDetailData.dgContact" @change="changeDgContact" :maxlength="20" @input="val => toupcaseTable(val, 'dgContact', goodsDetailData.$index)" placeholder="请输入危险品联系人" style="width: 320px;" :disabled="isEdit" />
            </div>
          </el-form-item>
          <el-form-item label="危险品联系人电话" prop="dgContactNumber" label-width="100px">
            <div style="position: relative;">
              <el-input show-word-limit v-model="goodsDetailData.dgContactNumber" @change="changeDgContactNumber" :maxlength="20" placeholder="请输入危险品联系人电话" style="width: 320px;" :disabled="isEdit" />
            </div>
          </el-form-item>
        </div>

        <!-- <el-col :span="8">
            <el-form-item label="货主箱标记" prop="ownContainer" label-width="100px">
              <el-select
                v-model="goodsDetailData.ownContainer"
                placeholder="请选择货主箱标记"
                :disabled="!isEdit"
              >
                <el-option value="SOC" label="SOC">SOC</el-option>
                <el-option value="COC" label="COC">COC</el-option>
              </el-select>
            </el-form-item>
          </el-col> -->

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="closeDialog">取 消</el-button>
      <el-button size="medium" type="primary" @click="submitGoods">确 认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { httpAgent } from "@/api/ajax";


var regCN = /[^\x00-\xff]/ig // 检测中文
var regSP = /^\S.*\S$|(^\S{0,1}\S$)/ // 检测空格

export default {
  name: 'GoodsDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modifyType: String,
    detailData: {
      type: Object,
      default: () => ({
        houseBillNo: '',
        containerNo: '',
        containerType: '',
        containerSn: '',
        dangerLevel: '',
        descriptionOfGoods: '',
        hsCode: '',
        marksNumber: '',
        ownContainer: '',
        sealNo: '',
        packageUnit: '',
        status: '',
        unCode: '',
        volume: '',
        grossWeight: '',
        packages: '',
        packageUnitSimpleVO: {}
      })
    }
    
  },
  data () {

    const regCM = /^[0-9.]+$/
    const validateCM = (rule, value, callback) => {
      if (regCM.test(value) === false) {
        callback(new Error('只能输入数字和.'))
      } else if (!regSP.test(value)) {
        callback(new Error('首尾不能包含空格'))
      } else {
        if (regCM.test(value) === false) {
          callback(new Error('只能输入数字和.'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          callback()
        }
      }
    }

    const regNum = /^[0-9]+$/
    const validateNum = (rule, value, callback) => {
      if (regCM.test(value) === false) {
        callback(new Error('只能输入数字'))
      } else if (!regSP.test(value)) {
        callback(new Error('首尾不能包含空格'))
      } else {
        if (regNum.test(value) === false) {
          callback(new Error('只能输入数字'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          callback()
        }
      }
    }

    const regex = /^[0-9A-Z]+$/
    const validateEX = (rule, value, callback) => {
      if (regex.test(value) === false) {
        callback(new Error('只能输入大写字母和数字'))
      } else if (!regSP.test(value)) {
        callback(new Error('首尾不能包含空格'))
      } else {
        if (regex.test(value) === false) {
          callback(new Error('只能输入大写字母和数字'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          callback()
        }
      }
    }

    //货名
    const regHm = /^[0-9A-Z-,/.:#%&*@;'"_()\\ \x0a]+$/
    const validateHM = (rule, value, callback) => {
      if (regHm.test(value) === false) {
        callback(new Error('输入不能有中文 & 小写字母 & 全角字符'))
      }else {
        if (regHm.test(value) === false) {
          callback(new Error('输入不能有中文 & 小写字母 & 全角字符'))
        }else {
          callback()
        }
      }
    }

    //唛头
    const regMT = /^[0-9a-zA-Z-,/.:#%&*@;'"()\\ \x0a]+$/
    const validateMT = (rule, value, callback) => {
      if (regMT.test(value) === false) {
        callback(new Error('输入不能有中文 & 小写字母 & 全角字符'))
      }else {
        if (regMT.test(value) === false) {
          callback(new Error('输入不能有中文 & 小写字母 & 全角字符'))
        }else {
          callback()
        }
      }
    }

    // const regXh = /^[A-Z]{3}U[0-9]{7}$/
    const regXh = /^[A-Z]{4}[0-9]{7}$/
    const validateXH = (rule, value, callback) => {
      if (regXh.test(value) === false) {
        callback(new Error('箱号不符合国际箱号编码规则'))
      } else if (!regSP.test(value)) {
        callback(new Error('首尾不能包含空格'))
      } else {
        if (regXh.test(value) === false) {
          callback(new Error('箱号不符合国际箱号编码规则'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          callback()
        }
      }
    }
    //危险品code
    const validateUnCode = (rule, value, callback) => {
      if(value != '' && value !=null){
        if (regCM.test(value) === false) {
          callback(new Error('只能输入数字'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          if (regNum.test(value) === false) {
            callback(new Error('只能输入数字'))
          } else if (!regSP.test(value)) {
            callback(new Error('首尾不能包含空格'))
          } else {
            callback()
          }
        }
      }else{
        callback()
      }
    }
    //危险品等级
    const validateDanger = (rule, value, callback) => {
      if(value != '' && value !=null){
        if (regCM.test(value) === false) {
          callback(new Error('必须是1位整数或者带1位小数的数字，1~9.9'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          if (regCM.test(value) === false) {
            callback(new Error('必须是1位整数或者带1位小数的数字，1~9.9'))
          } else if (!regSP.test(value)) {
            callback(new Error('首尾不能包含空格'))
          } else {
            callback()
          }
        }
      }else{
        callback()
      }
    }
    const regDanger = /^[0-9A-Z ]+$/
    const validateDang = (rule, value, callback) => {
      if(value != '' && value !=null && value !== undefined){
        if (regDanger.test(value) === false) {
          callback(new Error('只能输入数字,字母和空格'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          if (regDanger.test(value) === false) {
            callback(new Error('只能输入数字,字母和空格'))
          } else if (!regSP.test(value)) {
            callback(new Error('首尾不能包含空格'))
          } else {
            callback()
          }
        }
      }else{
        callback()
      }
    }

    const regDangerNum = /^[0-9]+$/
    const validateDangerNum = (rule, value, callback) => {
      if(value != '' && value !=null && value !== undefined){
        if (regDangerNum.test(value) === false) {
          callback(new Error('只能输入数字'))
        } else if (!regSP.test(value)) {
          callback(new Error('首尾不能包含空格'))
        } else {
          callback()
        }
      }else{
        callback()
      }
    }

    return {
      goodsDetailData: this.detailData,
      packageUnitSimpleVO: {},
      containerList: [], // 箱型
      packageList: [], // 包装单位
      selectLoading: false,

      tableRule: {
        houseBillNo: [
          { required: true, message: '请输入分提单号', trigger: ['blur', 'change'] },
          { min: 6, max: 30, message: '长度在6到30之间', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX, trigger: ['blur', 'change'] }
        ],
        containerNo: [
          { required: true, message: '请输入箱号', trigger: ['blur', 'change'] },
          { min: 0, max: 11, message: '长度小于等于11', trigger: ['blur', 'change'] },
          { required: true, validator: validateXH, trigger: ['blur', 'change'] }
        ],
        sealNo: [
          { required: true, message: '请输入封号', trigger: ['blur', 'change'] },
          { min: 0, max: 11, message: '长度小于等于11', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX, trigger: ['blur', 'change'] }
        ],
        containerType: [{ required: true, message: '请选择箱型', trigger: ['blur', 'change'] }],
        descriptionOfGoods: [
          { required: true, message: '请输入货名', trigger: ['blur', 'change'] },
          { min: 0, max: 255, message: '长度小于等于255', trigger: ['blur', 'change'] },
          { required: true, validator: validateHM, trigger: ['blur', 'change'] }
        ],
        packages: [
          { required: true, message: '请输入件数(1000000以内)', trigger: ['blur', 'change'] },
          { required: true, validator: validateNum, trigger: ['blur', 'change'] }
        ],
        grossWeight: [
          { required: true, message: '请输入毛重(0.001~1000000.999)', trigger: ['blur', 'change'] },
          { required: true, validator: validateCM, trigger: ['blur', 'change'] }

          // { min: 0, max: 11, message: '长度小于等于11', trigger: 'blur'},
        ],
        volume: [
          { required: true, message: '请输入体积(0.001~2000.999)', trigger: ['blur', 'change'] },
          { required: true, validator: validateCM, trigger: ['blur', 'change'] }

          // { min: 0, max: 8, message: '长度小于等于8', trigger: 'blur'},
        ],
        marksNumber: [
          { required: true, message: '请输入唛头', trigger: ['blur', 'change'] },
          { min: 0, max: 255, message: '长度小于等于255', trigger: ['blur', 'change'] },
          { required: true, validator: validateMT, trigger: ['blur', 'change'] }
        ],
        ownContainer: [{ required: true, message: '请选择货主箱标记', trigger: ['blur', 'change'] }],
        packageUnit: [{ required: true, message: '请选择包装单位', trigger: ['blur', 'change'] }],
        unCode: [
        { required: false, message: '必须是4位纯数字1000-9999', trigger: ['blur', 'change'] },
        { required: false, validator: validateUnCode, trigger: "blur" },
        ],
        dangerLevel: [
        { required: false, message: '必须是1位整数或者带1位小数的数字，1~9.9', trigger: ['blur', 'change'] },
        { required: false, validator: validateDanger, trigger: ['blur', 'change'] },
        ],
        dgContact: [
          { required: false, message: '请输入危险品联系人', trigger: ['blur', 'change'] },
          { required: false, validator: validateDang, trigger: ['blur', 'change'] }
        ],
        dgContactNumber: [
          { required: false, message: '请输入危险品联系人电话', trigger: ['blur', 'change'] },
          { required: false, validator: validateDangerNum, trigger: ['blur', 'change'] }
        ],
      },
      tableRuleDanger: {
        houseBillNo: [
          { required: true, message: '请输入分提单号', trigger: ['blur', 'change'] },
          { min: 6, max: 30, message: '长度在6到30之间', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX, trigger: ['blur', 'change'] }
        ],
        containerNo: [
          { required: true, message: '请输入箱号', trigger: ['blur', 'change'] },
          { min: 0, max: 11, message: '长度小于等于11', trigger: ['blur', 'change'] },
          { required: true, validator: validateXH, trigger: ['blur', 'change'] }
        ],
        sealNo: [
          { required: true, message: '请输入封号', trigger: ['blur', 'change'] },
          { min: 0, max: 11, message: '长度小于等于11', trigger: ['blur', 'change'] },
          { required: true, validator: validateEX, trigger: ['blur', 'change'] }
        ],
        containerType: [{ required: true, message: '请选择箱型', trigger: ['blur', 'change'] }],
        descriptionOfGoods: [
          { required: true, message: '请输入货名', trigger: ['blur', 'change'] },
          { min: 0, max: 255, message: '长度小于等于255', trigger: ['blur', 'change'] },
          { required: true, validator: validateHM, trigger: ['blur', 'change'] }
        ],
        packages: [
          { required: true, message: '请输入件数(1000000以内)', trigger: ['blur', 'change'] },
          { required: true, validator: validateNum, trigger: ['blur', 'change'] }
        ],
        grossWeight: [
          { required: true, message: '请输入毛重(0.001~1000000.999)', trigger: ['blur', 'change'] },
          { required: true, validator: validateCM, trigger: ['blur', 'change'] }

          // { min: 0, max: 11, message: '长度小于等于11', trigger: 'blur'},
        ],
        volume: [
          { required: true, message: '请输入体积(0.001~2000.999)', trigger: ['blur', 'change'] },
          { required: true, validator: validateCM, trigger: ['blur', 'change'] }

          // { min: 0, max: 8, message: '长度小于等于8', trigger: 'blur'},
        ],
        marksNumber: [
          { required: true, message: '请输入唛头', trigger: ['blur', 'change'] },
          { min: 0, max: 255, message: '长度小于等于255', trigger: ['blur', 'change'] },
          { required: true, validator: validateMT, trigger: ['blur', 'change'] }
        ],
        ownContainer: [{ required: true, message: '请选择货主箱标记', trigger: ['blur', 'change'] }],
        packageUnit: [{ required: true, message: '请选择包装单位', trigger: ['blur', 'change'] }],
        unCode: [
        { required: true, message: '必须是4位纯数字1000-9999', trigger: ['blur', 'change'] },
        { required: true, validator: validateUnCode, trigger: "blur" },
        ],
        dangerLevel: [
        { required: true, message: '必须是1位整数或者带1位小数的数字，1~9.9', trigger: ['blur', 'change'] },
        { required: true, validator: validateDanger, trigger: ['blur', 'change'] },
        ],
        dgContact: [
          { required: true, message: '请输入危险品联系人', trigger: ['blur', 'change'] },
          { required: true, validator: validateDang, trigger: ['blur', 'change'] }
        ],
        dgContactNumber: [
          { required: true, message: '请输入危险品联系人电话', trigger: ['blur', 'change'] },
          { required: true, validator: validateDangerNum, trigger: ['blur', 'change'] }
        ],
      },
      dangerType:false
    }
  },
  created () {
    this.$nextTick(() => {
      if((this.goodsDetailData && this.goodsDetailData.type) == 'UPDATE'){
        this.$refs['goodsDetailData'].validate((valid) => {
          console.log(valid)
        })
      }
    })


    this.getContainerList()
    if(this.goodsDetailData.packageUnit){
      this.getPackageList(this.goodsDetailData.packageUnit)
    }
    if(!this.goodsDetailData.houseBillNo && !this.goodsDetailData.containerNo){
      this.goodsDetailData = {
        houseBillNo: '',
        containerNo: '',
        containerType: '',
        containerSn: '',
        dangerLevel: '',
        descriptionOfGoods: '',
        hsCode: '',
        marksNumber: '',
        ownContainer: '',
        sealNo: '',
        packageUnit: '',
        status: '',
        unCode: '',
        volume: '',
        grossWeight: '',
        packages: '',
        packageUnitSimpleVO: {}
      }
    }
    if(this.goodsDetailData.unCode || this.goodsDetailData.dangerLevel) {
      this.dangerType = true
    } else {
      this.dangerType = false
    }
  },
  methods: {
    // 危险品联系电话
    changeDgContactNumber(e) {
      if(e || this.goodsDetailData.unCode || this.goodsDetailData.dgContact || this.goodsDetailData.dangerLevel) {
        this.dangerType = true
      } else {
        this.dangerType = false
      }
    },
    // 危险品联系人
    changeDgContact(e) {
      if(e || this.goodsDetailData.unCode || this.goodsDetailData.dangerLevel || this.goodsDetailData.dgContactNumber) {
        this.dangerType = true
      } else {
        this.dangerType = false
      }
    },
    // 危险品等级 输入后失去焦点
    changeDanger(e) {
      console.log(e)
      if(e || this.goodsDetailData.unCode || this.goodsDetailData.dgContact || this.goodsDetailData.dgContactNumber) {
        this.dangerType = true
      } else {
        this.dangerType = false
      }
    },
    // 危险品CODE 输入后失去焦点
    changeCode (e) {
      console.log(e)
      if(e || this.goodsDetailData.dangerLevel || this.goodsDetailData.dgContact || this.goodsDetailData.dgContactNumber) {
        this.dangerType = true
      } else {
        this.dangerType = false
      }
    },
    // select 失去焦点
    handBlur(val){
      console.log(val)
      this.$refs['goodsDetailData'].validateField(val, (e) => {
        console.log(e)
      })
    },
    // 获取箱型
    getContainerList(){
      httpAgent({
        url: `/agent/enums/container-type`,
        method: "get",
      }).then((res) => {
        this.containerList = res
      })
    },
    remoteMethodPackage(query){
      this.getPackageList(query)
    },
    // 更新包装单位
    changePackage(val){
      console.log(val)
      this.packageUnitSimpleVO = {}
      this.packageList.forEach(item => {
        if(item.code == val){
          this.packageUnitSimpleVO = item
        }
      })
      this.goodsDetailData.packageUnit = val
    },
    // 包装单位 获取焦点
    focusPackage(){
      if(this.packageList.length <= 0){
        this.getPackageList()
      }
    },
    // 获取包装单位
    getPackageList(val){
      this.selectLoading = true
      let param = {
        codeLike: val ? val : '',
        nameCnLike: val ? val : '',
        nameEnLike: val ? val : '',
        pageNum: 1,
        pageSize: 50,
      }
      httpAgent({
        url: `/agent/ccam/package-units/simpleLikeOr`,
        method: "get",
        data:param
      }).then((res) => {
        this.packageList = res.records
      }).finally(() => {
        this.selectLoading = false
      })
    },
    // 关闭
    closeDialog () {
      this.$emit('closeDialog')
      this.$refs.goodsDetailData.resetFields()
    },

    // 过滤掉数字前的0
    timeNumInput(val){
      this.goodsDetailData.packages = String(this.goodsDetailData.packages).replace(/\D/g, '');//过滤到非数字
      this.goodsDetailData.packages = parseInt(this.goodsDetailData.packages);
      if(isNaN(this.goodsDetailData.packages)){
          this.goodsDetailData.packages = ''
      }
    },
    
    // 确定
    submitGoods () {
      if (this.goodsDetailData.containerNo && (this.goodsDetailData.containerNo == this.goodsDetailData.sealNo)) {
        this.$message({
          message: '请注意，箱号和封号存在重复填写！',
          type: 'error'
        })
        return
      }
      this.$refs['goodsDetailData'].validate((valid) => {
        if (valid) {
          this.$emit('submitGoods', { ...this.goodsDetailData, packageUnitSimpleVO: this.packageUnitSimpleVO.code ? this.packageUnitSimpleVO : this.goodsDetailData.packageUnitSimpleVO})
        } else {
          console.log('error')
          return false
        }
      })
    },

    // 保留num位 有效数字
    toFixedNum (val, id, num) {
      // console.log(val.target, id)
      // console.log(val.target.value)
      if (id === 'packages') {
        if (val.target.value >= 0 && val.target.value <= 1000000) {
          this.goodsDetailData.packages = Number(val.target.value).toString()
          return
        } else {
          this.goodsDetailData.packages = ''
          return
        }
      }

      let e = ''
      if (!(/(^[1-9]\d*$)/.test(Number(val.target.value)))) {
        e = Number(val.target.value).toFixed(num)
      } else {
        e = Number(val.target.value)
      }


      if (id === 'grossWeight') {
        if (e >= 0.001 && e <= 1000000.999) {
          this.goodsDetailData.grossWeight = e.toString()
          return
        } else {
          this.goodsDetailData.grossWeight = ''
        }
      }
      if (id === 'volume') {
        if (e >= 0.001 && e <= 2000.999) {
          this.goodsDetailData.volume = e.toString()
          return
        } else {
          this.goodsDetailData.volume = ''
        }
      }
      if (id === 'dangerLevel') {
        if (e >= 1 && e <= 9.9) {
          console.log(1)
          this.goodsDetailData.dangerLevel = e.toString()
          return
        } else {
          this.goodsDetailData.dangerLevel = ''
          if(this.goodsDetailData.unCode || this.goodsDetailData.dgContact || this.goodsDetailData.dgContactNumber) {
            this.dangerType = true
          } else {
            this.dangerType = false
          }
        }
      }
      this.goodsDetailData[id] = ''
    },
    // 转大写
    toupcaseTable (val, id, index) {
      this.goodsDetailData[id] = val.toUpperCase()
    },

    trimTexTablet (e, id, index) {
      this.goodsDetailData[id] = e.target.value.trim()
    },
    // 长度为4的数字
    fourNum (val, id, index,) {
      // console.log(val.target.value)
      let e = val.target.value
      if (e.length === 4 && e > 0) {
        this.goodsDetailData[id] = e
      } else {
        this.goodsDetailData[id] = ''
        if (id === 'unCode') {
          if(this.goodsDetailData.dangerLevel || this.goodsDetailData.dgContact || this.goodsDetailData.dgContactNumber) {
            this.dangerType = true
          } else {
            this.dangerType = false
          }
        }
      }
    },

  }
}
</script>

<style lang="less" scoped>
.goods-detail-dialog {
  .el-form {
    .el-form-item {
      margin: 0 0 16px 24px;
    }
    .form-item-btn {
      width: 108px;
      margin-left: 16px;
    }
  }
}
</style>